export default __webpack_public_path__ + "a1d53710ecb11afdeb02dcf87036079a.svg";